var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){_vm.play()}}},[_c('i',{staticClass:"fa fa-5x fa-fw",class:_vm.nowPlaying ? 'fa-pause' : 'fa-play',staticStyle:{"font-size":"22px !important"},attrs:{"id":"player-play"}})])}
var staticRenderFns = []

export { render, staticRenderFns }